module.exports = __webpack_public_path__ + "static/16-2b8cbc24100aa15dacc44b5d36e9b5d7.jpg";